import { action, createRequestTypes } from './base';

export const taxActionTypes = {
  CREATE_TAX: createRequestTypes('CREATE_TAX'),
  GET_TAXES: createRequestTypes('GET_TAXES'),
  GET_TAX_TYPES: createRequestTypes('GET_TAX_TYPES'),
  UPDATE_TAX: createRequestTypes('UPDATE_TAX'),
  GET_TAX_TYPES: createRequestTypes('GET_TAX_TYPES'),
};

/**
 *
 */
class TaxActions {
  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createTax = (payload, callback) => action(taxActionTypes.CREATE_TAX.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param createTaxLoading
   * @return {{type: *}}
   */
  createTaxLoading = (createTaxLoading) => action(taxActionTypes.CREATE_TAX.LOADING, {
    createTaxLoading,
  })

  /**
   * @param orgId
   * @param page
   * @param limit
   * @param isActive
   * @param isTaxGroup
   * @param gstName
   * @return {{type: *}}
   */
  getTaxes = (orgId, page, limit, isActive, isTaxGroup, callback) => action(taxActionTypes.GET_TAXES.REQUEST, {
    orgId, page, limit, isActive, isTaxGroup, callback,
  })

  /**
   *
   * @param getTaxesLoading
   * @return {{type: *}}
   */
   getTaxesLoading = (getTaxesLoading) => action(taxActionTypes.GET_TAXES.LOADING, {
     getTaxesLoading,
   })

  /**
   * @param taxes
   * @return {{type: *}}
   */
  getTaxesSuccess = (taxes, isTaxGroup) => action(taxActionTypes.GET_TAXES.SUCCESS, {
    taxes,
    isTaxGroup,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updateTax = (payload, callback) => action(taxActionTypes.UPDATE_TAX.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param updateTaxLoading
   * @return {{type: *}}
   */
  updateTaxLoading = (updateTaxLoading) => action(taxActionTypes.UPDATE_TAX.LOADING, {
    updateTaxLoading,
  })

  /**
   * @param orgId
   * @param page
   * @param limit
   * @param isActive
   * @return {{type: *}}
   */
     getTaxTypes = (orgId, page, limit, isActive) => action(taxActionTypes.GET_TAX_TYPES.REQUEST, {
       orgId, page, limit, isActive,
     })

     /**
     *
     * @param getTaxTypesLoading
     * @return {{type: *}}
     */
     getTaxTypesLoading = (getTaxTypesLoading) => action(taxActionTypes.GET_TAX_TYPES.LOADING, {
       getTaxTypesLoading,
     })

    /**
     * @param taxTypes
     * @return {{type: *}}
     */
    getTaxTypesSuccess = (taxTypes) => action(taxActionTypes.GET_TAX_TYPES.SUCCESS, {
      taxTypes,
    })
}

export default new TaxActions();
